import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  Inject,
} from '@angular/core';
import { SlideInOutAnimation } from '@app/my-return/components/return-list-table/return-list-table.animation';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs/internal/Observable';
import { MyReturn, User, VWProgram } from '@app/core/models';
import { Store, select } from '@ngrx/store';
import { MatSort, Sort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { ReturnSubmitConfirmComponent } from '@app/my-return/components/return-submit-confirm/return-submit-confirm.component';
import { ReturnSaveConfirmComponent } from '@app/my-return/components/return-save-confirm/return-save-confirm.component';

import {
  AppState,
  BrandsActionTypes,
  selectProfile,
  selectProgram,
} from '@app/core/ngrx';
import { MyReturnActionTypes } from '@app/core/ngrx/actions/my-return.actions';
import { MyReturnService } from '@app/core/services';
import { tap } from 'rxjs/operators';
@Component({
  selector: 'ecp-return-list-table',
  templateUrl: './return-list-table.component.html',
  styleUrls: ['./return-list-table.component.scss'],
  animations: [SlideInOutAnimation],
})
export class ReturnListTableComponent implements OnInit {
  public changesDetected: boolean;
  ParentExample = 'Hello Angular!';
  // @select(['myreturn', 'list', 'brands'])
  // public myreturns$: Observable<MyReturn[]>;
  public myreturns$: Observable<any>;
  // @select(['myreturn'])
  //public returns$: Observable<MyReturn[]>;
  public returns$: Observable<any>;
  // @select(['myreturn', 'selectedBrand'])
  public selectedBrand$: Observable<string>;
  // @select(['myreturn', 'searchTerm'])
  public searchTerm$: Observable<string>;
  public refreshNames: Observable<string>;
  // @select(['user', 'profile'])
  user$: Observable<User>;
  @ViewChild('sortSection') sortSection: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  public brand: any = {};
  public searchTerm = '';
  public returnFrames = [];
  private brands = [];
  public refreshId;
  public shippingLabel = '';
  public isCompleted = false;

  // @select(['user', 'profile', 'program'])
  public program$: Observable<VWProgram>;
  theme = 'one-portal';
  formulaSubmitted: boolean;
  panelDisplay: Array<number> = [];

  isSaved = false;
  constructor(
    public dialog: MatDialog,
    private store: Store<AppState>,
    private myReturnService: MyReturnService,
  ) {}

  ngOnInit(): void {
    // this.myreturns$ = this.store.pipe(
    //   select(state => state.myReturn.list.brands),
    // );
    this.myreturns$ = this.store.select(
      state => state.myReturn.selectedReturn.brands,
    );
    this.returns$ = this.store.pipe(select(state => state.myReturn));
    this.selectedBrand$ = this.store.pipe(
      select(state => state.myReturn.selectedBrand),
    );
    this.searchTerm$ = this.store.pipe(
      select(state => state.myReturn.searchTerm),
    );
    this.user$ = this.store.pipe(select(selectProfile));
    this.program$ = this.store.pipe(select(selectProgram));
    this.program$.pipe().subscribe(program => {
      if (program) {
        this.theme = program.programKey;
      }
    });
    this.returns$.pipe().subscribe((myReturn: any) => {
      if (myReturn.loaded) {
        this.formulaSubmitted = false;
        let brands = myReturn.selectedReturn.brands;
        this.brands = brands;
        this.refreshId = myReturn.selectedReturn.refreshId;
        this.shippingLabel = myReturn.selectedReturn.shippingLabel;
        this.refreshNames = myReturn.refreshNames;
        this.isCompleted = myReturn.selectedReturn.isCompleted;
        let frameReturn = this.markAsReturned(myReturn.selectedReturn.brands);
        if(frameReturn){
          this.isSaved = true;
          this.changesDetected = false;
        }
      }
    });
    this.selectedBrand$.subscribe(selectedBrand => {
      this.brand = { ...this.brand, selectedBrand: selectedBrand };
    });

    this.searchTerm$.subscribe(searchTerm => {
      this.searchTerm = searchTerm;
    });
  }
  markAsReturned(returnData:any){
    let res = returnData.some(brands =>
      brands.modules.some(modules=>
        modules.frames.some(frame=>
          frame.isReturned === true
        )));
    return res;
  }
  sortData(sort: Sort): void {
    const matSortHeaderEls: Element[] = [].slice.call(
      this.sortSection.nativeElement.querySelectorAll('[mat-sort-header]'),
    );
    matSortHeaderEls.forEach(matSortHeaderEl =>
      matSortHeaderEl.removeAttribute('aria-sort'),
    );

    if (!sort.active || !sort.direction) {
      return;
    }

    const sortheader = this.sortSection.nativeElement.querySelector(
      `[mat-sort-header="${sort.active}"]`,
    );
    if (sortheader) {
      sortheader.setAttribute('aria-sort', sort.direction);
    }
  }

  discardChanges() {
    this.changesDetected = false;
    this.store.dispatch({ type: MyReturnActionTypes.LOAD_MY_RETURN });
  }

  valueChanged(ob, frame) {
    if (ob.checked) {
      this.returnFrames.push({
        fpc: frame.fpc,
        IsReturned: true,
      });
    } else {
      const idx = this.returnFrames.findIndex(x => x.fpc === frame.fpc);
      if (idx > -1) {
        this.returnFrames.splice(idx, 1);
      }
    }
    this.changesDetected = this.returnFrames.length > 0;
  }

  openReturnConfirmDialog(): void {
    const dialogRef = this.dialog.open(ReturnSubmitConfirmComponent, {
      width: '600px',
      maxWidth: '89.3vw',
      maxHeight: '82vh',
      //      data: {name: this.name, animal: this.animal}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed with ' + result);
      if (result === true) {
        this.myReturnService
          .postReturn({
            refreshId: this.refreshId,
            isComplete: true,
            returnFrames: this.returnFrames,
          })
          .subscribe(() => {
            this.store.dispatch({
              type: MyReturnActionTypes.LOAD_MY_RETURN,
            });
          });
      }
    });
  }

  openReturnSaveConfirmDialog(): void {
    const dialogRef = this.dialog.open(ReturnSaveConfirmComponent, {
      width: '600px',
      maxWidth: '89.3vw',
      maxHeight: '82vh',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The save dialog was closed with ' + result);
      if (result === true) {
        this.myReturnService
          .postReturn({
            refreshId: this.refreshId,
            isComplete: false,
            returnFrames: this.returnFrames,
          })
          .subscribe(() => {
            this.store.dispatch({
              type: MyReturnActionTypes.LOAD_MY_RETURN,
            });
          });
      }
    });
  }
}
